var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasGridImages)?_c('GridGallery',{key:_vm.renderKey,attrs:{"grid-images":_vm.gridImages,"column-count":_vm.columnCount,"column-gap":_vm.columnGap,"is-masonry-layout":_vm.isMasonryLayout}}):_c('EmptyGallery')}
var staticRenderFns = []

export { render, staticRenderFns }